import ConnectedPaymentsTab from './ConnectedPaymentsTab';

export default ConnectedPaymentsTab;
